<template>
  <button
    class="flex flex-col p-5 group text-dark-neutral-500 text-left border-mid-neutral-50 border-b w-full transition gap-1"
    :class="[
      {
        'bg-blue-50 !border-blue-500': isActive,
        ' cursor-not-allowed ': isDisabled,
        'hover:bg-blue-50 hover:border-blue-500': !isDisabled,
      },
    ]"
    :disabled="isDisabled"
    @click="emit('handle')"
  >
    <div class="space-y-1 flex-1 flex items-center justify-between w-full">
      <p class="text-secondary-500 text-base tracking-tighter">
        {{ title }}
      </p>
      <div
        v-if="isAutomated"
        class="bg-tertiary-50 text-tertiary-500 text-sm px-3 py-1 rounded-full"
      >
        FULLY AUTOMATED
      </div>
    </div>
    <p
      class="text-slate-900 font-semibold transition leading-6 py-1 tracking-tighter text-lg"
      :class="{
        '!text-primary ': isActive,
        'group-hover:text-primary ': !isDisabled,
      }"
    >
      {{ subtitle }}
    </p>

    <p class="text-slate-500 font-400 text-sm leading-5">
      {{ description }}
    </p>
  </button>
</template>
<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    description?: string
    isActive?: boolean
    isDisabled?: boolean
    isAutomated?: boolean
  }>(),
  {
    isActive: false,
    subtitle: '',
    description: '',
    isDisabled: false,
    isAutomated: false,
  },
)
const emit = defineEmits<(e: 'handle') => void>()
</script>
